import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import { inAppNotificationsMarkAsRead } from '~/generated';
import { extractData } from '~/utils/query-utils';

export const useMarkInAppNotificationAsRead = (
  options: UseMutationOptions<void, unknown, number, unknown> = {}
) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) =>
      extractData(inAppNotificationsMarkAsRead({ path: { id } })),
    onSuccess(...args) {
      queryClient.invalidateQueries({
        queryKey: ['InAppNotifications'],
      });
      options.onSuccess?.(...args);
    },
    ...options,
  });
};
